/**
 * @Date: 2022-07-14 10:53:10
 * @LastEditTime: 2022-07-14 10:53:10
 * @Description:  API - CMS模块
 */
import axios from '@/common/js/request'
// import QS from 'qs'
const cms = {
	// 文章 - 列表
	apiCmsList(data, loading = true) {
		return axios.get('/api/CMS/open/Article_GetList', { params: data, loading })
	},
	// 文章 - 分类列表
	apiCmsCategoryList(data, loading = true) {
		return axios.get('/api/CMS/open/Articleclass_GetChannel', { params: data, loading })
	},
	// 文章 - 详情
	apiCmsDetail(data, loading = true) {
		return axios.get('/api/CMS/open/Article_Details', { params: data, loading })
	},
	// 获取验证码
	getCodeImg() {
		return axios.get('/api/CMS/captchaImage')
	},
	submitOpinion(data) {
		return axios.post('/api/CMS/addOpinion', data)
	}

}

export default cms
